<template>
    <Overlay :show="showLoading">
        <b-card no-body>
            <div class="card-header pb-0">
                <div class="col-md-8 pl-0">
                    <b-card-title>
                        {{ $t('Component(EchaS2SClientSettings):title') }}
                    </b-card-title>
                </div>
                <div class="col-md-4">
                    <div class="demo-inline-spacing float-right">
                        <Button v-if="showSaveButton" class="mr-0 mt-0" :disabled="isSaveButtonDisabled" @click="save">
                            {{ $t('Component(Button):save') }}
                        </Button>
                    </div>
                </div>
            </div>
            <div class="p-2">
                <b-alert
                    show
                    class="mt-0"
                    variant="warning"
                >
                    <div class="alert-body" v-html="$t('Component(EchaS2SClientSettings):instruction')"/>
                </b-alert>
                <validation-observer ref="settings">
                    <b-form-group
                        :label="$t('Component(EchaS2SClientSettings):label-username')"
                        label-for="username"
                    >
                        <validation-provider
                            #default="{ errors }"
                            :name="$t('Component(EchaS2SClientSettings):label-username')"
                            rules="required"
                        >
                            <b-form-input
                                :state="errors.length > 0 ? false:null"
                                id="username"
                                v-model="key.username"
                                @input="onChange"
                                :placeholder="$t('Component(EchaS2SClientSettings):placeholder-username')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <b-form-group
                        :label="$t('Component(EchaS2SClientSettings):label-legalEntityUuid')"
                        label-for="legalEntityUuid"
                    >
                        <validation-provider
                            #default="{ errors }"
                            :name="$t('Component(EchaS2SClientSettings):label-legalEntityUuid')"
                            rules="required"
                        >
                            <b-form-input
                                :state="errors.length > 0 ? false:null"
                                id="legalEntityUuid"
                                v-model="key.legalEntityUuid"
                                @input="onChange"
                                :placeholder="$t('Component(EchaS2SClientSettings):placeholder-legalEntityUuid')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <b-form-group
                        :label="$t('Component(EchaS2SClientSettings):label-s2skey')"
                        label-for="s2skey"
                    >
                        <validation-provider
                            #default="{ errors }"
                            :name="$t('Component(EchaS2SClientSettings):label-s2skey')"
                            rules="required"
                        >
                            <b-form-input
                                :state="errors.length > 0 ? false:null"
                                id="s2skey"
                                v-model="key.s2sKey"
                                @input="onChange"
                                :placeholder="$t('Component(EchaS2SClientSettings):placeholder-s2skey')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </validation-observer>
            </div>
        </b-card>
    </Overlay>
</template>
<script setup>
import {BCard, BCardTitle, BFormGroup, BFormInput, BAlert} from 'bootstrap-vue'
import Overlay from "@core/components/common/Overlay.vue";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {Button} from "@core/components/common";
import {EchaApi} from "@core/api";
import backendResponse from "@core/mixins/ui/backend-response";

export default {
    mixins: [backendResponse],
    components: {
        Overlay, BCard, BCardTitle,ValidationProvider, ValidationObserver, BFormGroup, BFormInput, Button,
        BAlert
    },
    props: {
        organizationId: {
            default: null,
        },
        showSaveButton: {
            default: false,
        },
        showSuccessPopup: {
            default: false
        },
        manageLoading: {
            default: false
        },
        manageFailedResponse: {
            default: false
        }
    },
    data() {
        return {
            showLoading: false,
            isSaveButtonDisabled: true,
            hasChanges: false,

            key: {
                username: '',
                legalEntityUuid: '',
                s2sKey: ''
            }
        }
    },
    methods: {
        onChange() {
            this.isSaveButtonDisabled = !(this.key.username && this.key.legalEntityUuid && this.key.s2sKey);
            this.hasChanges = true;
        },
        save() {
            if (!this.hasChanges) {
                return new Promise((resolve, reject) => {
                    resolve();
                });
            }
            if (this.manageLoading) {
                this.showLoading = true;
            }
            return EchaApi
                .saveS2SKey(
                    this.organizationId,
                    this.key.username,
                    this.key.legalEntityUuid,
                    this.key.s2sKey
                )
                .then((r) => {
                    this.hasChanges = false;
                    if (this.showSuccessPopup) {
                        this.showDefaultSuccessMessage(
                            this.$t('Component(EchaS2SClientSettings):success-popup-message'),
                            true,
                            this.$t('Component(EchaS2SClientSettings):success-popup-title'),
                        );
                    }
                })
                .catch(e => {
                    if (this.manageFailedResponse) {
                        this.handleBackendError(e);
                    } else {
                        throw e;
                    }
                })
                .finally(() => {
                    if (this.manageLoading) {
                        this.showLoading = false;
                    }
                })
            ;
        }
    },
    created() {
        if (this.organizationId) {
            this.showLoading = true;
            EchaApi
                .getS2sKey(this.organizationId)
                .then(r => {
                    this.key = r.data;
                    this.onChange();
                })
                .catch((e) => {})
                .finally(() => this.showLoading = false)
            ;
        }
    }
};
</script>
